  export const extractImageFromDescription = (description) => {
    if (!description) return null;
    const imgMatch = description.match(/<img[^>]+src=["']([^"']+)["'][^>]*>/i);
    return imgMatch ? imgMatch[1] : null;
  };

  export const removeFirstImageFromDescription = (description) => {
    if (!description) return description;
    return description.replace(/<img[^>]*>/i, "");
  };
